import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PreferencesService } from 'src/app/services/preferences.service';

@Component({
  selector: 'app-personalities-edit',
  templateUrl: './personalities-edit.component.html',
  styleUrls: ['./personalities-edit.component.css']
})
export class   PersonalityEditComponent implements OnInit {
  personalityEditForm!:FormGroup;
  submitted: any;
  token: any;
  personalityData: any;
  id:any;
  image: any;
  imageSrc: any;
  fileName!: string;


  constructor(public router: Router,
    private prefrencesService: PreferencesService,
    private toastr : ToastrService,
    private activateroute: ActivatedRoute,
    private formBuilder : FormBuilder
    ) { }

  ngOnInit(): void {
    this.id = this.activateroute.snapshot.paramMap.get('id');
    this.personalityEditForm = this.formBuilder.group({
      name: ['',[Validators.required,this.prefrencesService.noSpacesValidator]],
      image:['']
    });
    this.geteditData()
  }

  get editForm() {return this.personalityEditForm.controls;}
 
  onImageSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.image = file;
      this.fileName =  file.name
      this.createImagePreview(file);
    }
  }

  createImagePreview(file: File) {
    const reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageSrc = event.target.result;
    };
    reader.readAsDataURL(file);
  }
  
  geteditData(){
    let obj = {
      working_as_id : this.id
    };
    this.token = localStorage['token'];
    this.prefrencesService.personalityDtls(obj, this.token).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.personalityData = res.data;
        this.personalityEditForm.patchValue({
          name:this.personalityData.name,
        });
        const imageName=this.personalityData.image.split('/')
        this.fileName=imageName[imageName?.length - 1]
        this.image = this.personalityData.image;
        this.personalityEditForm.value.image = this.image;
        if (this.image) {
          this.imageSrc = this.image;  // Assuming image is a URL or base64 data
        }
        // this.toastr.success(res.message);
      }
      else{
        this.toastr.success(res.message);
        alert(res.message);
      }
    });
  }

  onSubmit(){
    this.submitted = true;
    if (this.personalityEditForm.invalid) {
      return;
    }
    this.token = localStorage['token'];
    let formData = new FormData();
    formData.append('name', this.personalityEditForm.get('name')?.value);
    formData.append('image', this.image);
    formData.append('id', this.id);
    this.prefrencesService.editPersonality(formData,this.token).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.toastr.success(res.message);
        this.router.navigate(['/personality']);
        this.personalityEditForm.reset();
        this.submitted = false;
      }
    });
  }

}
